import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import IsOutdoorShadeSelector from '../../ShadeForm/IsOutdoorShadeSelector';


import Button from '../../../Parts/Button';
import Money from '../../../Parts/Money';
import { EditPSOutdoorShadeModalInner } from '../../EditPSOutdoorShadeModal';
import { useNewPSOutdoorShadeOptions } from '../../../Store/entities/assemblies/PSOutdoorHooks';
import { addAssembly, InitialAssemblyState, InitialShadeState } from '../../../Store/entities/assemblies';
import { useQuoteById, useQuoteTypeNameByQuoteId } from '../../../Store/entities/quotes/hooks';
import { AssemblyStore, AssemblyViewModelFromAssemblyStore } from '../../../Store/entities/assemblies/types';
import { EditIndoorShadeModalInner } from '../../EditIndoorShadeModal';
import { useNewIndoorShadeOptions } from '../../../Store/entities/assemblies/IndoorHooks.ts';
import apiCalls from '../../../PowerShadesAPIFunctions';
import { UsePortalDispatch } from '../../../Store';
import { useIndoorFabrics, usePSOutdoorFabrics } from '../../../Store/entities/hooks';
import { useUser } from '../../../Store/user/hooks';


type NewQuoteItemFormProps = {
	quoteId: number;
	onCancel: () => void;
}

type AddOptions = '' | 'psoutdoor' | 'indoor'

const NewQuoteItemForm = ({
	quoteId,
	onCancel
}: NewQuoteItemFormProps) => {

	const [currentShadeType, setCurrentShadeType] = useState<AddOptions>('');

	const [currentAssembly, setCurrentAssembly] = useState<AssemblyStore>({ ...InitialAssemblyState(), shades: [InitialShadeState()] });

	const indoorFabrics = useIndoorFabrics();
	const psOutdoorFabrics = usePSOutdoorFabrics();

	const user = useUser();
	const quote = useQuoteById(quoteId);

	const psOutdoorOptions = useNewPSOutdoorShadeOptions(currentAssembly, setCurrentAssembly, { fabrics: psOutdoorFabrics, user, quote });
	const indoorOptions = useNewIndoorShadeOptions(currentAssembly, setCurrentAssembly, { fabrics: indoorFabrics, user, quote });

	const dispatch = UsePortalDispatch();

	const [{
		errors,
		price
	}, setAssemblyViability] = useState({
		errors: "",
		price: 0
	});

	useEffect(() => {
		apiCalls.calculateAssemblyPriceNew(AssemblyViewModelFromAssemblyStore(currentAssembly), quoteId, currentShadeType).then((res) => {
			const errorMessage = res?.data?.errors;
			const errorMessageListAsOneString = errorMessage?.join(", ") ?? "";
			setAssemblyViability({
				price: res?.data?.msrp ?? 0,
				errors: errorMessageListAsOneString
			})
		});
	}, [currentAssembly])

	const msrp = price;


	const selectIndoor = () => {
		setCurrentShadeType("indoor")
	}

	const selectOutdoor = () => {
		setCurrentShadeType("psoutdoor")
	}

	const attemptAdd = () => {
		// TODO Check if the assembly is valid

		dispatch(addAssembly({
			quoteId,
			newAssembly: currentAssembly,
			shadeType: currentShadeType
		}))
		onCancel();
	}

	// const done = (isCanceled = true) => {

	// 	if (isCanceled && newSequenceId != 0) {
	// 		dispatch(deleteAssemblies({
	// 			quoteId,
	// 			sequenceIds: [newSequenceId]
	// 		}))
	// 	}
	// 	try {
	// 		// this.props.newQuote.UI.reRenderTable();
	// 		onCancel();
	// 	} catch (e) {
	// 		// ROOT.alert({
	// 		// 	quickFormat: 'error',
	// 		// 	message: 'Something went wrong. Please try again.'
	// 		// });
	// 		// throw new Error(`Error closing new shade form and re-rendering quote table: ${e}`);
	// 	}
	// }


	// const {
	// 	isOutdoorShade, userMultiplier, fetchingPrice, shadeErrors, doneGettingId
	// } = this.state;

	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	// const add_button_disabled = fetchingPrice || isOutdoorShade === null || shadeErrors.length;

	const doneGettingId = true;
	const add_button_disabled = false;

	const fetchingPrice = false;

	return (
		<>
			<h3 className={`text-${quoteType}`}>
				{currentShadeType === ""
					? 'New Shade'
					: currentShadeType === "psoutdoor"
						? 'New Outdoor Shade'
						: 'New Indoor Shade'}
			</h3>
			{currentShadeType !== "" && doneGettingId ? (
				<h4 className={`text-${quoteType}`}>All Fields Required</h4>
			) : null}

			{currentShadeType === "" ? (
				<IsOutdoorShadeSelector
					quoteType={quoteType}
					selectOutdoor={selectOutdoor}
					selectIndoor={selectIndoor}
					selectLighting={() => {
						window.open('https://powershades.com/interior-roller-shades', '_blank');
					 }}
				/>
			) : (
				<Col className=''>
					<Row />
					{
						currentShadeType == "psoutdoor" ? <EditPSOutdoorShadeModalInner
							// options, quoteType, isNotAdd = true, unlocked = true, massEdit
							options={psOutdoorOptions}
							quoteType={quoteType}
							isNotAdd={false}
							unlocked={true}
							massEdit={false}
						/>
							:
							<EditIndoorShadeModalInner
								//options, quoteType, isNotAdd = true, unlocked = true, massEdit 
								options={indoorOptions}
								quoteType={quoteType}
								isNotAdd={false}
								unlocked={true}
								massEdit={false}
							/>
					}
					<Row />

				</Col>

			)}

			{currentShadeType !== "" && (
				price !== 0 ? (
					<div className={`shade-price text-${quoteType}`}>
						<Money value={msrp} />
					</div>
				) : <text>
					{errors}
				</text>
			)}

			<Container className="local-bootstrap">
				<Row className="mt-4 mb-2">
					<Col sm={6} xl={4}>
						<Button fullWidth color="grey" onClick={onCancel}>
							Cancel
						</Button>
					</Col>
					<Col xl={4} className="d-none d-xxl-block d-xl-block" />
					<Col sm={6} xl={4} className="text-end">
						<Button
							fullWidth
							disabled={add_button_disabled}
							color={quoteType}
							onClick={attemptAdd}
						>
							{fetchingPrice ? 'Calculating...' : 'Add Shade'}
						</Button>
					</Col>
				</Row>
			</Container>
		</>
	);
}

export default NewQuoteItemForm;